import { render, staticRenderFns } from "./Tiptap.vue?vue&type=template&id=618376c5"
import script from "./Tiptap.vue?vue&type=script&lang=js"
export * from "./Tiptap.vue?vue&type=script&lang=js"
import style0 from "./Tiptap.vue?vue&type=style&index=0&id=618376c5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports